import { findLastAtOrBefore } from "@domain/Utilities";
import type { RobotTimeline } from "../types/Robot";
import type { MissionStateRun } from "./missionStateRibbon";

/**
 * Returns the timeline segment whose `[start, end]` contains `ts`, or null
 * when none. Uses the binary-search primitive (`findLastAtOrBefore`) and
 * adds the `ts ≤ segment.end` upper-bound check that's specific to bounded
 * intervals.
 *
 * Each consumer was previously inlining this seven-line lookup; six copies
 * existed across desktop and mobile vms before this extraction.
 */
export function findActiveSegment(timeline: readonly RobotTimeline[], ts: number): RobotTimeline | null {
	const s = findLastAtOrBefore(timeline, ts, (seg) => seg.start);
	return s && ts <= s.end ? s : null;
}

/** Same algorithm as {@link findActiveSegment} but for mission-state runs. */
export function findActiveMissionStateRun(runs: readonly MissionStateRun[], ts: number): MissionStateRun | null {
	const r = findLastAtOrBefore(runs, ts, (run) => run.start);
	return r && ts <= r.end ? r : null;
}
